module.exports = __webpack_public_path__ + "img/finalboss.1d95f2da.jpg";